import { render, staticRenderFns } from "./DigitalKey.vue?vue&type=template&id=4aaa5a3e"
import script from "./DigitalKey.vue?vue&type=script&lang=js"
export * from "./DigitalKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports